export enum AcceptanceTermsType {
  AppUseTerms = 'appUseTerms',
  AppPrivacyTerms = 'appPrivacyTerms',
  Laundry = 'laundry',
  Cleaning = 'cleaning',
  Maid = 'maid',
  Market= 'market',
  Furniture = 'furniture',
}

export default AcceptanceTermsType;
